import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionButton } from "@corporate-trip-planner-fe/ui-components";
import { Button } from "@mui/material";
import { ActionButtons } from "../../../pages/trip-details/trip-details.style";
import { TripAccessCode } from "../../../utils/enums/TripAccessCode";
import { TripMemberStatus } from "../../../utils/enums/TripMemberStatus";
var TripActionButtons = function (_a) {
    var tripPrivacy = _a.tripPrivacy, userStatus = _a.userStatus, actionLoading = _a.actionLoading, onJoin = _a.onJoin, onRequestJoin = _a.onRequestJoin, onCancelRequestJoin = _a.onCancelRequestJoin, onAcceptInvite = _a.onAcceptInvite, onDeclineInvite = _a.onDeclineInvite, onLeave = _a.onLeave;
    if (userStatus === TripMemberStatus.JOINED) {
        return (_jsx(ActionButtons, { children: _jsx(ActionButton, { variant: "outlined", color: "error", loading: actionLoading, onClick: onLeave, children: "Leave Trip" }) }));
    }
    if (tripPrivacy === TripAccessCode.PUBLIC &&
        (userStatus === TripMemberStatus.NOT_JOINED || userStatus === TripMemberStatus.LEFT)) {
        return (_jsx(ActionButtons, { children: _jsx(ActionButton, { variant: "contained", color: "primary", loading: actionLoading, onClick: onJoin, children: "Join Trip" }) }));
    }
    if (tripPrivacy === TripAccessCode.APPROVAL) {
        if (userStatus === TripMemberStatus.NOT_JOINED || userStatus === TripMemberStatus.LEFT || userStatus === TripMemberStatus.REQUEST_CANCELLED) {
            return (_jsx(ActionButtons, { children: _jsx(ActionButton, { variant: "contained", color: "primary", loading: actionLoading, onClick: onRequestJoin, children: "Request to Join" }) }));
        }
        else if (userStatus === TripMemberStatus.REQUESTED) {
            return (_jsx(ActionButtons, { children: _jsx(ActionButton, { variant: "outlined", color: "warning", loading: actionLoading, onClick: onCancelRequestJoin, children: "Cancel Request" }) }));
        }
    }
    if (tripPrivacy === TripAccessCode.INVITE) {
        if (userStatus === TripMemberStatus.INVITED) {
            return (_jsxs(ActionButtons, { children: [_jsx(ActionButton, { variant: "contained", color: "success", loading: actionLoading, onClick: onAcceptInvite, children: "Accept Invite" }), _jsx(ActionButton, { variant: "outlined", color: "error", loading: actionLoading, onClick: onDeclineInvite, children: "Decline" })] }));
        }
        else {
            return (_jsx(ActionButtons, { children: _jsx(Button, { variant: "outlined", disabled: true, fullWidth: true, color: "info", children: "Invite Only Trip" }) }));
        }
    }
    return null; // fallback for unsupported states
};
export default TripActionButtons;
